/**
 * Relatório de cliente só abre com login (16/09/2026: havia gente vendendo com
 * links nossos, que abriam sem login e valiam para sempre).
 *
 * Exceção: o link de winback /relatorio-winback/{hash}?acesso=TOKEN, gerado pela
 * equipe e válido por 24h. O hash do perfil não muda (o Reinaldo usa no CRM); o
 * token fica na aba e vai no header X-Report-Access só nas chamadas de relatório
 * daquele perfil.
 */

export const HEADER_DO_LINK = "X-Report-Access";

const PREFIXO_DO_TOKEN = "relatorio-acesso:";
const CHAVE_DO_DESTINO = "relatorio-destino";
const UUID = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
const PAGINA_DE_RELATORIO = new RegExp(
  `^/(?:dashboard|relatorio|relatorio-winback|reports/keywords)/${UUID}(?:/|$)`,
  "i",
);
const CHAMADA_DE_RELATORIO = new RegExp(
  `/(?:dashboard/profile|keywords/profile|reports/keywords|reports/performance)/(${UUID})`,
  "i",
);

const sessao = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const ehPaginaDeRelatorio = (pathname: string): boolean => PAGINA_DE_RELATORIO.test(pathname);

/** Chamar antes das requisições do relatório: guarda o ?acesso= do link. */
export const guardarAcessoDoLink = (profileId: string | undefined, search: string): void => {
  if (!profileId) return;
  const token = new URLSearchParams(search).get("acesso");
  if (token) sessao()?.setItem(PREFIXO_DO_TOKEN + profileId.toLowerCase(), token);
};

/** Token do link para esta chamada, se for chamada de relatório de um perfil com link aberto. */
export const acessoParaAChamada = (url: string | undefined): string | null => {
  const perfil = url?.match(CHAMADA_DE_RELATORIO)?.[1];
  if (!perfil) return null;
  return sessao()?.getItem(PREFIXO_DO_TOKEN + perfil.toLowerCase()) ?? null;
};

export const guardarDestinoDoLogin = (pathname: string, search: string): void => {
  if (ehPaginaDeRelatorio(pathname)) sessao()?.setItem(CHAVE_DO_DESTINO, pathname + search);
};

/** Relatório que mandou para o login. Lido uma vez; só aceita página de relatório deste site. */
export const destinoDepoisDoLogin = (): string | null => {
  const armazenamento = sessao();
  const destino = armazenamento?.getItem(CHAVE_DO_DESTINO) ?? null;
  armazenamento?.removeItem(CHAVE_DO_DESTINO);
  if (!destino || destino.startsWith("//")) return null;
  return ehPaginaDeRelatorio(destino.split("?")[0]) ? destino : null;
};

/** Para onde mandar depois de um 401; null quando já está no login. */
export const loginPara401 = (pathname: string, estavaLogado: boolean): string | null => {
  if (pathname.startsWith("/login")) return null;
  return !estavaLogado && ehPaginaDeRelatorio(pathname) ? "/login?relatorio=1" : "/login?sessao=expirada";
};

export const linkDeWinback = (origem: string, profileId: string, token: string): string =>
  `${origem}/relatorio-winback/${profileId}?acesso=${encodeURIComponent(token)}`;

/** "2026-09-17T19:04:10" (horário do servidor) → "17/09 às 19:04". */
export const validadeDoLink = (expiresAt: string): string => {
  const partes = expiresAt?.match(/^\d{4}-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  return partes ? `${partes[2]}/${partes[1]} às ${partes[3]}:${partes[4]}` : "";
};
